import { ref, readonly } from 'vue'

export const usePolling = () => {
  const activePolls = ref(new Map())

  /*
    * Starts a polling interval for a given unique identifier and callback function.
    * If a polling interval with the same identifier already exists, it will be cleared before starting a new one.
   */
  const startPolling = (id: string, callback:() => void, interval: number = 3000) => {
    if (activePolls.value.has(id)) {
      stopPolling(id)
    }

    const intervalId = setInterval(callback, interval)
    activePolls.value.set(id, intervalId)

    return intervalId
  }

  const stopPolling = (id: string) => {
    const intervalId = activePolls.value.get(id)
    if (intervalId) {
      clearInterval(intervalId)
      activePolls.value.delete(id)
    }
  }

  const stopAllPolling = () => {
    activePolls.value.forEach((intervalId) => clearInterval(intervalId))
    activePolls.value.clear()
  }

  return {
    startPolling,
    stopPolling,
    stopAllPolling,
    activePolls: readonly(activePolls)
  }
}
